import React, { useState } from 'react';
import { BettingSites } from "../data";
import {
    BetWayLogo,
    MarcaLogo,
    Bet365Logo,
    PastonLogo,
    BwinLogo,
    WilliamHillLogo,
    CodereLogo,
    LuckiaLogo,
    SportiumLogo,
    BetfairLogo,
    ApuestasLogo,
    OnexbetLogo,
    LeoVegasLogo,
    NoLogo
} from "./Logos";

import './componentsStyle/BonosWidget.css';
import './componentsStyle/OpinionesWidget.css';

const validLogos = {
    "Betway": BetWayLogo,
    "Marca": MarcaLogo,
    "Bet365": Bet365Logo,
    "Paston": PastonLogo,
    "Bwin": BwinLogo,
    "WilliamHill": WilliamHillLogo,
    "Codere": CodereLogo,
    "Luckia": LuckiaLogo,
    "Sportium": SportiumLogo,
    "Betfair": BetfairLogo,
    "Onexbet": OnexbetLogo,
    "LeoVegas": LeoVegasLogo,
    "Apuestas": ApuestasLogo
};

{/* TODO - TRANSFORM INTO COMPONENT*/ }
const Logo = props => {
    let TagName = NoLogo;

    const logoName = props.name.replace(/\s/g, '');

    if (typeof validLogos[logoName] !== "undefined") {
        TagName = validLogos[logoName];
    }

    return (
        <TagName className="logo-opiniones" name={props.name} classsSuffix={props.classsSuffix} />
    );
};


const BonosRow = props => {
    return (
        <div className="object-card top-bonos">

            <div className="numb-recomm text-center">
                {'#' + props.rank }
            </ div>

            <div className="name-recomm bet-site-name">
                <Logo className="logo-opiniones" name={props.name} classsSuffix={"-bonos"}/>
            </ div>

            <div className="bonus-recomm title-text text-center">
                <div className="rating-recomm">
                    <div className="rating-recomm__numb">
                        <div className="rating-recomm__numb__svg">
                            <svg xmlns="http://www.w3.org/2000/svg" height="22" idth="22" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 
                                15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" fill="#1F1B24"/>
                            </svg> 
                        </ div>   
                        <div className="rating-recomm__numb__val">
                            {props.rating}
                        </ div>
                    </ div>            

                    <div className="review-recomm">
                        <a href={props.reviewUrl}>
                            <div className="review-recomm__label">
                                Leer Opinión
                        </ div>
                        </ a>
                    </ div> 
                </ div>                         
            </ div> 

            <div className="bonus-eu-recomm text-center dashed-red-border">
                <div className="bonus-eu-recomm-text">
                    {props.bonoEuros}€
                    </ div>
                <div className="bonus-recomm__label">
                    bono del 100% hasta
                </ div>
            </ div>

            <div className="play-recomm__pos">
                <a href={props.bonoUrl} target="blank" className="play-recomm md-btn text-center">
                    Jugar Ahora
                </ a>
            </ div>
        </ div>
    )
};

const BonosWidget = (props) => {
    let endPoint = BettingSites.length;
    let startPoint = 0;

    if (props.endPoint !== undefined &&
        props.endPoint !== null &&
        props.endPoint <= BettingSites.length) {
        endPoint = props.endPoint;
    }

    if (props.startPoint !== undefined &&
        props.startPoint !== null &&
        props.startPoint >= 0) {
        startPoint = props.startPoint;
    }

    const [bonos, setBonos] = useState(BettingSites.slice(startPoint, endPoint));

    return (
        <div className="game">
            <div className="bonos-widget-container">
                {bonos.map(b => (
                    <BonosRow
                        key={b.id}
                        rank={b.rank}
                        name={b.name}
                        bonoEuros={b.bonoEuros}
                        reviewUrl={b.reviewUrl}
                        bonoUrl={b.bonoUrl}
                        rating={b.rating}
                    />
                ))}
            </div>
        </div>
    );
};

export default BonosWidget;